var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { width: "100%", height: "100%" } }, [
    _c(
      "table",
      { staticClass: "editor" },
      [
        _c(
          "thead",
          [
            _vm._l(_vm.selected_schema, function(field) {
              return _c(
                "th",
                {
                  key: field.name,
                  staticClass: "column-header",
                  style: _vm.header_style(field),
                  on: {
                    click: function($event) {
                      _vm.sort_list(field.name)
                    }
                  }
                },
                [_vm._v(_vm._s(field.name))]
              )
            }),
            _vm._v(" "),
            _c("th", { staticClass: "column-header delete-column" }),
            _vm._v(" "),
            _c("th", { staticClass: "column-header copy-column" }),
            _vm._v(" "),
            _c("th", { staticClass: "column-header move-column" })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "draggable",
          {
            attrs: {
              element: "tbody",
              value: _vm.displayed_parts,
              options: { handle: ".move-handle" }
            },
            on: { end: _vm.part_drag_drop_end }
          },
          _vm._l(_vm.displayed_parts, function(part) {
            return _c("PartsListPart", {
              key: part.name,
              attrs: { part: part }
            })
          })
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("input", {
      staticClass: "new-part-button",
      attrs: { type: "button", value: "Add new part" },
      on: { click: _vm.add_new_part }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5488bfb0", { render: render, staticRenderFns: staticRenderFns })
  }
}